import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
  } from '@angular/common/http';
  import { Observable, throwError } from 'rxjs';
  import { map, catchError } from 'rxjs/operators';
  import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
  
  @Injectable()
  export class HttpConfigInterceptor implements HttpInterceptor {
    
    constructor(private router: Router, private _snackBar: MatSnackBar) { }

    clearLogin() {
      localStorage.clear();
      this._snackBar.open("Please login again", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.router.navigate(['']);
    }
  
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      console.log(request);
      const token = localStorage.getItem("accessToken");
      const expiresIn = localStorage.getItem("expiresIn");
      const currentTime = new Date().getTime();
      console.log(expiresIn, (+expiresIn - currentTime), (+expiresIn - currentTime) > 10 * 60 * 1000);
      if(request.url.indexOf("/open/login") < 0) {
        if(expiresIn && (+expiresIn - currentTime) > 10 * 60 * 1000) {
          //TODO later use refresh token at this point to set new access token
        }
        else {
          if(expiresIn) {
            if((+expiresIn - currentTime) <= 0) {
              console.log('clearLogin 1');
              this.clearLogin();
            }
          }
        }
      }
      
      if (token) {
        request = request.clone({
          setHeaders: {
            'Authorization':  `Bearer ${token}`
          }
        });
      }
  
      if (!request.headers.has('Content-Type')) {
        request = request.clone({
          setHeaders: {
            'content-type': 'application/json'
          }
        });
      }
  
      request = request.clone({
        headers: request.headers.set('Accept', 'application/json')
      });
  
      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // console.log('event--->>>', event);
          }
          return event;
        }),
        catchError((error: HttpErrorResponse) => {
          console.error(error);
          return throwError(error);
        }));
    }
  
  
  }